import Api from 'client/api/v2/Api';
import axios from 'axios';

class DynamicControlsApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2';
  }

  /**
   * @param {string} enterpriseId - Enterprise Id
   * @param {array of Objects} filters - Filter Object
   */
  async getDynamicControlsDropdownOptions(resource, filterField, filterValue) {
    const filterString = filterField && filterValue ? `?filter=${filterField}:eq:${filterValue}` : '';
    const url = `${this.baseUrl}/${resource}`;
    await this.initialize();
    const resp = await axios.get(url + filterString);
    return resp.data;
  }
}

export default new DynamicControlsApi();
